import { useEffect, useMemo } from 'react';

import MasonryGridVertical from 'components/MasonryGridVertical/MasonryGridVertical';

import TemplateItem from './TemplateItem';
import { MasonryGridProps } from './types';

const TemplatesMasonryGrid = ({ masonryData, FirstElement = null }: MasonryGridProps) => {
  const elements = useMemo(() => {
    const items = masonryData.map(template => (
      <TemplateItem key={`${template?.id}-${template?.url}`} template={template} />
    ));
    return FirstElement ? [<div key="first-element">{FirstElement}</div>, ...items] : items;
  }, [FirstElement, masonryData]);

  // Todo: remove this pop after this task is closed: https://picsart.atlassian.net/browse/PIA-243268
  useEffect(() => {
    masonryData.pop();
  }, [masonryData]);

  return (
    <MasonryGridVertical
      columnsCount={{ Small: 2, Medium: 3, Large: 4, ExtraLarge: 5 }}
      gap={24}
      dataTestId="templates-masonry-grid"
    >
      {elements}
    </MasonryGridVertical>
  );
};

export default TemplatesMasonryGrid;
